module.exports = __webpack_public_path__ + "img/17_10.4aa6c12d.png";